module.exports = __webpack_public_path__ + "static/img/circular.ae5d7c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/circular.png
// module id = UEV7
// module chunks = 1